import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, SimpleGrid, Heading } from '@chakra-ui/react';

import StoreCard from './components/StoreCard';
import FiltersSection from './components/FiltersSection';
import { useColors } from './components/colors';

import { getStoresApi, updateRefreshTokenApi } from 'features/stores/stores.api';

const Stores = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { textColor } = useColors();

  const { stores } = useSelector((state) => state.stores);
  const { list: supplierOptions } = useSelector((state) => state.suppliers);
  const { list: marketplaceOptions } = useSelector((state) => state.marketplaces);

  const [searchValue, setSearchValue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedMarketplace, setSelectedMarketplace] = useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const state = urlParams.get('state');
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (state && code) {
      dispatch(updateRefreshTokenApi({ state, code }));
      navigate(location.pathname, { replace: true });
    } else if (error) {
      navigate(location.pathname, { replace: true });
    }
  }, [dispatch, location, navigate]);

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 10,
      search: searchValue,
      marketplace: selectedMarketplace[0],
      supplier: selectedSuppliers[0],
      status: selectedStatus[0],
    };

    dispatch(getStoresApi(filters));
  }, [dispatch, searchValue, selectedStatus, selectedMarketplace, selectedSuppliers]);

  return (
    <Box px={{ base: 4, md: 10 }} py={{ base: 6, md: 8 }} mt="50px">
      <Heading as="h1" size="xl" mb={6} color={textColor}>
        Stores
      </Heading>

      <FiltersSection
        searchValue={searchValue}
        selectedStatus={selectedStatus}
        selectedMarketplace={selectedMarketplace}
        selectedSuppliers={selectedSuppliers}
        onSearch={setSearchValue}
        onSearchSubmit={setSearchValue}
        onStatusChange={setSelectedStatus}
        onMarketplaceChange={setSelectedMarketplace}
        onSuppliersChange={setSelectedSuppliers}
        marketplaces={marketplaceOptions}
        suppliers={supplierOptions}
        statusOptions={[
          { value: 'sync-active', label: 'Sync Active' },
          { value: 'sync-inactive', label: 'Sync Inactive' },
        ]}
      />

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing={6}>
        {stores.map((store) => (
          <StoreCard key={store._id} store={store} />
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default Stores;
